module.exports = __webpack_public_path__ + "img/thumbnail_Jaguar_j_albino.7321e85d.png";